import onboardingFrame1 from './frame1.png';

export const OboardingImagesLocalee = [onboardingFrame1];
